export function isMultiCartHotelItem(item: App.MultiCartItem): item is App.MultiCartInstantBookingLEHotelItem {
  return item.type === 'hotel'
}

export function isMultiCartBedbankHotelItem(item: App.MultiCartItem): item is App.MultiCartBedbankHotelItem {
  return item.type === 'bedbankHotel'
}

export function toAutoDeleteCandidates(itemIds: Array<string>): Array<{ itemId: string }> {
  return itemIds.map(itemId => ({ itemId }))
}

export function toCurrentStates(items: Array<Pick<App.MultiCartItem, 'id' | 'state'>>): Record<string, App.MultiCartItemState> {
  return Object.fromEntries(items.map(item => [item.id, item.state]))
}
